export default __webpack_public_path__ + "static/media/supadezign.acc51bfc.png";